import "./App.scss";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/Home";
import About from "./components/About";
import Contacts from "./components/Contacts";
import Courses from "./components/Courses";
import Projects from "./components/Projects";
import Diplomas from "./components/Diplomas";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="diplomas" element={<Diplomas />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="courses" element={<Courses />} />
          <Route path="projects" element={<Projects />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
